/**
 * Streaming guide — consuming real-time events from agent runs.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { streamingContent } from "@/constants/docs/streaming";

export const Route = createFileRoute("/docs/streaming")({
	component: StreamingPage,
});

function StreamingPage() {
	return <DocsPage title="Streaming" content={streamingContent} />;
}
